/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : models/auth/index.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Interface definitions for Auth related data
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import { IAppConfig } from "shared/utils";

export enum EnumTokenType {
  Auth,
  Refresh,
}

interface IAppConfigObj {
  type: EnumTokenType;
  appConfig: IAppConfig;
}

export interface IGetAuthTokenRequestArgs extends IAppConfigObj {
  code: string;
}

export interface IGetRefreshTokenRequestArgs extends IAppConfigObj {
  refresh_token: string;
}

export interface ITokenState {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  scope: string;
  token_type: string;
}

export interface IUserInfoState {
  avatar: string;
  given_name: string;
  family_name: string;
  name: string;
  customer_sub: string;
}

export interface IUserContactDetails {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNo: string;
}

export interface IAuthState {
  token: ITokenState | null;
  userInfo: IUserInfoState | null;
  userContactDetails: IUserContactDetails | null;
}

export interface IDecodedAccessToken {
  exp: number;
}
